module.exports = __webpack_public_path__ + "img/scale-class.7929aa31.png";